import * as React from 'react'

import { observer } from 'mobx-react'

import ExportEmployeeSelector from 'modules/employees/components/ExportEmployeesModal/ExportFields/ExportEmployeeSelector'
import ExportLeaveSelector from 'modules/employees/components/ExportEmployeesModal/ExportFields/ExportLeaveSelector'
import ExportMonthSelector from 'modules/employees/components/ExportEmployeesModal/ExportFields/ExportMonthSelector'
import type ReportsForm from 'modules/employees/lib/forms/Reports'

interface Props {
  form: ReportsForm
}

const ScheduleTimeoffFields = ({ form }: Props) => {
  return (
    <>
      <ExportEmployeeSelector form={form} />
      <ExportLeaveSelector form={form} />
      <ExportMonthSelector form={form} />
    </>
  )
}

export default observer(ScheduleTimeoffFields)
